import { consumerThemeConfig } from './consumer/config';
import { banffThemeConfig } from './banff/config';
import { banffConsumerThemeConfig } from './banff-consumer/config';
import { cortinaThemeConfig } from './cortina/config';
var defaultThemeConfig = {
  name: 'Enterprise'
};
export var themeList = [defaultThemeConfig, consumerThemeConfig, banffThemeConfig, banffConsumerThemeConfig, cortinaThemeConfig];
export default themeList;
export { defaultThemeConfig, consumerThemeConfig, banffThemeConfig, banffConsumerThemeConfig, cortinaThemeConfig };